import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL } from "@/lib/site-data";

export const FloatingCall = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      data-testid="floating-call-btn"
      href={`tel:${PHONE_TEL}`}
      className="md:hidden fixed bottom-20 right-4 z-40 inline-flex items-center gap-2 bg-bgtp-orange text-white px-5 py-3 shadow-[4px_4px_0_0_#C0C0C0] font-heading uppercase tracking-wider"
      aria-label="Appeler BGTP"
    >
      <Phone className="w-5 h-5" /> Appeler
    </a>
  );
};
